import React, { useState, useCallback, useEffect } from 'react';
import { Form, Input, Message, Checkbox } from '@b-design/fusion';
import Button, { FormSubmit, promisifyValidate } from '@/components/Button';
import './index.less';
import $i18n from '../../../../i18n';
import Requests from '@/services/request';
import { Field, Icon } from '@alifd/next';
import PrivacyPolicy from '../privacyPolicy';
import { getQueryStringArgs } from '@/utils/url-parse';
import { isPublicDeploy } from '@/utils/config';

interface register {
  changeIsLogin: () => void;
}

const Register: React.FC<register> = ({ changeIsLogin }) => {
  const field = Field.useField();
  const { getValue, validate, setValues } = field;
  const { email, invitationCode } = getQueryStringArgs();

  const [loading, setLoading] = useState<boolean>(false);
  // email是否验证通过
  const [readySendCode, setReadySendCode] = useState<boolean>(false);

  // 倒计时
  const [time, setTime] = useState<number>(0);
  // const times = useRef<number | null>(null);

  useEffect(() => {
    if (email) {
      setValues({ account: email });
      accountValidator(null, email);
    }
  }, []);

  // 提交按钮
  const submitForm = async (value, error) => {
    if (error) {
      return;
    }
    const { account, nickName, password, verifyCode } = value;
    const params = {
      account,
      nickName,
      password,
      verifyCode,
      invitCode: invitationCode,
    };
    const res = await Requests.post('/rest/intercnn/user/register', { ...params });
     if (res) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.login.registerSuccessful',
            dm: '注册成功',
          }),
        });
        changeIsLogin();
      }
  };

  const onValidate = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }
    await submitForm(vals, errs);
  };

  // 邮箱验证
  const accountValidator = (rule, value) => {
    return new Promise((resolve, reject) => {
      const regex = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,}$/;
      if (!regex.test(value)) {
        // setTime(0);
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.email.msg',
            dm: '请输入正确的邮箱格式',
          }),
        );
      } else {
        setReadySendCode(true);
        resolve(null);
        // if (times.current) {
        //   clearInterval(times.current);
        // }
        // setTime(60);
        // if (!times.current) {
        //   setTime(60)
        // }
      }
    });
  };

  // 密码验证
  const passwordValidator = (rule, value) => {
    return new Promise<void>((resolve, reject) => {
      // const regex = / ^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#&()-\[{}\]:\;',?/*~$^+=<>]).{8,20}$/;
      if (value) {
        validate(['confirmPassword']);
      }
      const regNum = /(\d)+/g;
      const regUppercase = /[A-Z]+/g;
      const regLowercase = /[a-z]+/g;
      const regSpecial = /([!@#&()\-\[{}\]:\;',?/*~$^+=<>])+/g;
      const regComplete = /^[a-zA-Z0-9!@#&()\-\[{}\]:\;',?/*~$^+=<>]{8,20}$/;

      if (!regNum.test(value)) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.number',
            dm: '请至少输入一个数字',
          }),
        );
      } else if (!regUppercase.test(value)) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.uppercase',
            dm: '请至少输入一个大写字母',
          }),
        );
      } else if (!regLowercase.test(value)) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.lowercase',
            dm: '请至少输入一个小写字母',
          }),
        );
      } else if (!regSpecial.test(value)) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.special',
            dm: '请至少输入一个特殊字符',
          }),
        );
      } else if (value?.length < 8 || value?.length > 20) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.length',
            dm: '请输入8-20个字符',
          }),
        );
      } else if (!regComplete.test(value)) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.password.notAllowspecial',
            dm: '输入了非法字符',
          }),
        );
      } else {
        resolve();
      }
    });
  };

  // 确认密码验证
  const confirmPasswordValidator = (rule, value) => {
    return new Promise((resolve, reject) => {
      if (value && value !== getValue('password')) {
        return reject(
          $i18n.get({
            id: 'aopf.pages.login.registerForm.inconsistent.msg',
            dm: '前后密码不一致。',
          }),
        );
      } else {
        return resolve(null);
      }
    });
  };

  // 发送验证码
  // const sendCode = useCallback(
  //   () => {
  //     validate('account', async (err, values: any) => {
  //       if (err) {
  //         return;
  //       }

  //       setLoading(true);
  //       const res = await Requests.post('/rest/intercnn/user/global/sendRegisterCode', { mail: values?.account })
  //       setLoading(false);
  //       if (time) {
  //         setTime(59);
  //         times.current = window.setInterval(() => { setTime(res => res - 1) }, 1000);
  //       }
  //     });
  //   },
  //   [time],
  // );

  // useEffect(() => {
  //   if (!time && times.current) {
  //     clearInterval(times.current);
  //     times.current = 0;
  //     setTime(60)
  //   }
  // }, [time, times.current])

  const counting = useCallback((time = 180) => {
    if (time < 0) return;
    setTime(time);
    setTimeout(() => {
      counting(time - 1);
    }, 1000);
  }, []);

  // 校验email并发送验证码
  const handleValidateAccount = useCallback(async () => {
    const [err, values] = await promisifyValidate(field, ['account']);
    if (err) {
      return;
    }
    const data = await Requests.post('/rest/intercnn/user/global/sendRegisterCode', {
      mail: values?.account,
    });
    if (data) {
      counting();
    } else {
      setReadySendCode(false);
    }
  }, [counting]);

  const _isPublicDeploy = isPublicDeploy();
  return (
    <div className="register-form">
      <div className="register-text">
        {$i18n.get({
          id: 'aopf.pages.login.registerTitle',
          dm: '注册',
        })}
      </div>
      <Form field={field} style={{ maxWidth: '400px', margin: '0 auto', marginTop: '16px' }}>
        <div className="form-content">
          <Form.Item
            style={{ marginBottom: '0px' }}
            name="account"
            label={$i18n.get({
              id: 'aopf.pages.login.registerForm.label.account',
              dm: '账号',
            })}
            required
            requiredMessage={$i18n.get({
              id: 'aopf.pages.login.registerForm.email.required',
              dm: '请输入邮箱！',
            })}
            validator={accountValidator.bind(null)}
            className="form-item-account"
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.login.registerForm.account.placeholder',
                dm: 'example@email.com',
              })}
              showLimitHint
              maxLength={64}
              // style={{ marginBottom: '0px' }}
              disabled={!!email}
              onPressEnter={onValidate}
            />
            {/* <Button type="secondary" onClick={sendCode} disabled={time !== 60} style={{ width: '120px' }}>
            {loading && <Icon type="loading" />}
            {!(time % 60) ? $i18n.get({
              id: 'aopf.pages.login.signUp.sendCode',
              dm: '发送验证码',
            }) : $i18n.get({
              id: 'aopf.pages.login.signUp.reSendCode',
              dm: '重新发送',
            }) + `(${time})`}
          </Button> */}

            {time === 0 && (
              <Button
                type="secondary"
                disabled={!readySendCode}
                onClick={handleValidateAccount}
              >
                {$i18n.get({
                  id: 'aopf.pages.login.signUp.sendCode',
                  dm: '发送验证码',
                })}
              </Button>
            )}
            {time > 0 && (
              <Button type="secondary" disabled={true}>
                {$i18n.get({
                  id: 'aopf.pages.login.signUp.reSendCode',
                  dm: '重新发送',
                }) + `(${time})`}
              </Button>
            )}
          </Form.Item>

          <Form.Item
            style={{ marginBottom: '0px' }}
            name="verifyCode"
            label={$i18n.get({
              id: 'aopf.pages.login.registerForm.label.verificationCode',
              dm: '验证码',
            })}
            required
            requiredMessage={$i18n.get({
              id: 'aopf.pages.login.registerForm.require.verificationCode',
              dm: '请输入验证码',
            })}
            minLength={6}
            maxLength={6}
            minmaxLengthMessage={$i18n.get({
              id: 'aopf.pages.login.registerForm.require.verificationCode.length',
              dm: '请输入6位验证码',
            })}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.login.registerForm.label.verificationCode.placeholder',
                dm: '请输入验证码',
              })}
              maxLength={6}
              onPressEnter={onValidate}
            />
          </Form.Item>

          <Form.Item
            style={{ marginBottom: '0px' }}
            name="password"
            label={$i18n.get({
              id: 'aopf.pages.login.registerForm.label.password',
              dm: '密码',
            })}
            required
            requiredMessage={$i18n.get({
              id: 'aopf.pages.login.PleaseEnterThePassword',
              dm: '请输入您的密码',
            })}
            validator={passwordValidator.bind(null)}
          >
            <Input.Password
              placeholder={$i18n.get({
                id: 'aopf.pages.login.registerForm.password.placeholder',
                dm: '8-20个字符',
              })}
              onPressEnter={onValidate}
            />
          </Form.Item>

          <Form.Item
            style={{ marginBottom: '0px' }}
            name="confirmPassword"
            label={$i18n.get({
              id: 'aopf.pages.login.registerForm.label.confirmPassword',
              dm: '确认密码',
            })}
            required
            requiredMessage={$i18n.get({
              id: 'aopf.pages.login.PleaseEnterTheConfirPassword',
              dm: '请输入确认密码！',
            })}
            validator={confirmPasswordValidator.bind(null)}
          >
            <Input.Password
              placeholder={$i18n.get({
                id: 'aopf.pages.login.registerForm.confirmPassword.placeholder',
                dm: '再次输入密码',
              })}
              onPressEnter={onValidate}
            />
          </Form.Item>

          <Form.Item
            style={{ marginBottom: '0px' }}
            name="nickName"
            label={$i18n.get({
              id: 'aopf.pages.login.registerForm.label.fullName',
              dm: '全名',
            })}
            required
            requiredMessage={$i18n.get({
              id: 'aopf.pages.login.PleaseEnterTheFllName',
              dm: '请输入名称！',
            })}
            minLength={2}
            maxLength={32}
            minmaxLengthMessage={$i18n.get({
              id: 'aopf.pages.login.registerForm.nickName.lengthMessage',
              dm: '输入2-32个字符的名称',
            })}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.login.registerForm.nickName.placeholder',
                dm: '名称',
              })}
              showLimitHint
              maxLength={32}
              onPressEnter={onValidate}
            />
          </Form.Item>
          {_isPublicDeploy && (
            <Form.Item
              style={{ marginBottom: '0px' }}
              name="check"
              label=""
              required
              requiredMessage={$i18n.get({
                id: 'aopf.pages.login.registerForm.agreement.required',
                dm: '请勾选协议',
              })}
              valueName="checked"
            >
              <Checkbox data-size="small" value="agree">
                <span style={{ fontSize: '12px', letterSpacing: '0.4px' }}>
                  {$i18n.get({
                    id: 'aopf.pages.login.register.agreement.describeA',
                    dm: '我已经阅读并接受',
                  })}
                </span>
                <span
                  style={{ color: 'var(--superapp-primary-1)' }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-privacy-policy');
                  }}
                >
                  《{$i18n.get({ id: 'aopf.pages.login.PrivacyPolicy', dm: 'Privacy Policy' })}》
                </span>
                <span
                  style={{ color: 'var(--superapp-primary-1)' }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-membership-agreement',
                    );
                  }}
                >
                  《
                  {$i18n.get({
                    id: 'aopf.pages.login.MembershipServiceAgreement',
                    dm: 'Membership Agreement',
                  })}
                  》
                </span>
                <span
                  style={{ color: 'var(--superapp-primary-1)' }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-product-terms-of-service');
                  }}
                >
                  《{$i18n.get({ id: 'aopf.pages.login.ProductTerms', dm: 'Product Terms' })}》
                </span>
                <span
                  style={{ color: 'var(--superapp-primary-1)' }}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(
                      'https://www.alibabacloud.com/help/en/legal/latest/alibaba-cloud-international-website-terms-of-use-alibaba-cloud-international-website-terms-of-use',
                    );
                  }}
                >
                  《{$i18n.get({ id: 'aopf.pages.login.WebsiteTermsOfUse', dm: 'Terms of Use' })}》
                </span>
              </Checkbox>
            </Form.Item>
          )}
          <PrivacyPolicy />
        </div>

        <Form.Item name="btn">
          <FormSubmit
            type="primary"
            onClick={onValidate}
            validate
            style={{
              height: 40,
              width: 400,
              borderRadius: 4,
              fontWeight: 500,
              fontSize: 16,
              color: '#fff',
              letterSpacing: '0.15px',
              marginBottom: '0px',
            }}
          >
            {$i18n.get({
              id: 'aopf.pages.login.register.creatAccount',
              dm: '注册账号',
            })}
          </FormSubmit>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Register;
